import type { AppTranslations } from 'translations/translations';
import type { Vrf } from '../fetchVrf';
import { isVrfAutodetect } from './isVrfAutodetect';

interface VRFOption {
  label: string;
  value: Vrf;
}

export const getVrfOption = (vrf: Vrf, msg: AppTranslations): VRFOption => ({
  label: isVrfAutodetect(vrf)
    ? msg.canvasGraph.graphSidePanel.pathlookup.vrfOptions.autoDetect
    : vrf || msg.canvasGraph.graphSidePanel.pathlookup.vrfOptions.empty,
  value: vrf,
});
